exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".welcome {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  background: #2CC185;\n  color: white;\n  width: 100%;\n  height: 100%;\n  overflow: hidden; }\n  .welcome .zonifero-services-logo {\n    -ms-flex-item-align: center;\n        -ms-grid-row-align: center;\n        align-self: center;\n    margin-bottom: 15%;\n    width: 25em;\n    max-width: 100%;\n    overflow: hidden; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/WelcomeComponent/welcome.component.scss
// module id = ./src/app/common/components/WelcomeComponent/welcome.component.scss
// module chunks = main